<script type="text/javascript">
    import SingleRangeCalendar from '@/components/Form/Calendar/SingleRange.vue';
    
    export default {
        SingleRangeCalendar,
    }
</script>